/**
 * Created by Administrator on 2017/3/24.
 */
var common = {};

/**
 * 获取指定标签对象
 * @param id 标签的id属性值
 * @returns {Element}根据id属性值返回指定标签对象
 */
common.id=function(id) {
  return document.getElementById(id);
}
//获取class名
common.class = function(cls){
  return  document.getElementsByClassName(cls);
}
//获得样式
common.getStyle=function(element, attr) {
  return element.currentStyle ? element.currentStyle[attr] : window.getComputedStyle(element, null)[attr];
}

//关于事件参数对象的工具的代码
common.evtTools = {
  //事件参数
  evt: function(e) {
    return window.event ? window.event : e;
  },
  //页面向左卷曲出去的距离
  left: function() {
    return window.pageXOffset || document.body.scrollLeft || document.documentElement.scrollLeft || 0;
  },
  //页面向上卷曲出去的距离
  top: function() {
    return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0;
  },
  //事件参数对象中的属性封装---可视区域的横坐标
  clientX: function(e) {
    return this.evt(e).clientX;
  },
  //事件参数对象中的属性封装---可视区域的纵坐标
  clientY: function(e) {
    return this.evt(e).clientY;
  },
  pageX: function(e) {
    return this.evt(e).pageX ? this.evt(e).pageX : this.left() + this.clientX(e);
  },
  pageY: function(e) {
    return this.evt(e).pageY ? this.evt(e).pageY : this.top() + this.clientY(e);
  }
};


common.getStyle = function(element, attr) {
  var result = element.currentStyle ? element.currentStyle[attr] : window.getComputedStyle(element, null)[attr];
  if (result == "auto") {
    return 0;
  } else {
    return result;
  }
};

//为元素绑定多个属性的兼容代码
common.addEventListener = function(element, style, fn) {
  if (typeof(element.addEventListener) != "undefined") {
    element.addEventListener(style, fn, false);
  } else if (typeof(element.attachEvent) != "undefined") {
    element.attachEvent("on" + style, fn)
  } else {
    element["on" + style] = fn;
  }
};

//解绑兼容函数
common.removeEventListener = function(element, type, fn) {
  if (typeof(element.removeEventListener) != "undefined") {
    element.removeEventListener(type, fn)
  } else if (typeof(element.detachEvent) != "undefined") {
    element.detachEvent("on" + type, fn)
  } else {
    element["on" + click] = null;
  }
};

//设置传递路由的参数
common.setResObj = function(param) {
  // console.log(param)
  var data = {};
  if (param.restaurantId){
    data.restaurantId = param.restaurantId;
  } else if (param.restraurantId){
    data.restaurantId = param.restraurantId
  }
  // restaurantId
  data.id = param.id;
  if (param.restaurantSyncId) {
    data.restaurantSyncUnique = param.restaurantSyncId;
  } else if (param.restaurantSyncUnique && param.syncUnique) {
    data.restaurantSyncUnique = param.restaurantSyncUnique;
    data.dishId = param.id;
  } else if (param.syncUnique) {
    data.restaurantSyncUnique = param.syncUnique;
  }
  if(param.click){
    data.click = true;
  }
  if(param.dishId){
    data.dishId = param.dishId
  }
  return data;  
}

export default common;



// WEBPACK FOOTER //
// ./src/components/js/common.js